

































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Wallet } from '@/store/wallet/types';

import { extendedDate } from '@/filters/date';
import {
  MandateTypes,
  MandateStatus,
} from '@/enum/mangoPay/MandateTypes';
import { User } from '@/store/profile/types';
import ExporoTooltip from '@/components/_common/Tooltip.vue';

@Component({
  name: 'wallet-details',
  filters: {
    extendedDate,
  },
  components: {
    ExporoTooltip,
  },
})
export default class chargeWallet extends Vue {
  @Prop({ required: true }) wallet: Wallet;
  @Prop({ required: true }) user: User;
  private beneficiaryAddress: boolean = false;

  beneficiaryShowAddress() {
    this.beneficiaryAddress = !this.beneficiaryAddress;
  }
}
